import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FieldsInterventionsDashboardComponent } from './fields-interventions-dashboard.component';
import {DxScrollViewModule, DxToolbarModule} from 'devextreme-angular';
import {DashboardWidgetModule} from '../../dashboard/dashboard-widget/dashboard-widget.module';
import {ExamplePieWidgetModule} from '../../dashboard/widgets/example-pie-widget/example-pie-widget.module';
import {ExampleBarWidgetModule} from '../../dashboard/widgets/example-bar-widget/example-bar-widget.module';
import {ExampleGridWidgetModule} from '../../dashboard/widgets/example-grid-widget/example-grid-widget.module';
import {ExampleNumberWidgetModule} from '../../dashboard/widgets/example-number-widget/example-number-widget.module';
import {TractorsPerDomainWidgetModule} from '../../dashboard/widgets/tractors-per-domain-widget/tractors-per-domain-widget.module';
import {DashboardSectionModule} from '../../dashboard/dashboard-section/dashboard-section.module';
import {FieldsInterventionTimeWidgetModule} from './widgets/fields-intervention-time-widget/fields-intervention-time-widget.module';



@NgModule({
  declarations: [FieldsInterventionsDashboardComponent],
  imports: [
    CommonModule,
    DxScrollViewModule,
    DashboardWidgetModule,
    ExamplePieWidgetModule,
    ExampleBarWidgetModule,
    ExampleGridWidgetModule,
    ExampleNumberWidgetModule,
    TractorsPerDomainWidgetModule,
    DxToolbarModule,
    DashboardSectionModule,
    FieldsInterventionTimeWidgetModule
  ],
  exports: [FieldsInterventionsDashboardComponent]
})
export class FieldsInterventionsDashboardModule { }
